// @flow

import MarkdownContent from './markdown-content'

export default MarkdownContent
